const settings = {
  env: {},
}

window.settings = settings

const envs = import.meta.env

const jsonEnvs = {
  APP_VERSION: 'undefined',
  APP_API_URL: '__APP_API_URL__',

  APP_DEFAULT_LANGUAGE: '__APP_DEFAULT_LANGUAGE__',
  APP_LANGUAGES: ['ru'],

  APP_OPEN_REPLAY_PROJECT_KEY: '__APP_OPEN_REPLAY_PROJECT_KEY__',
  APP_OPEN_REPLAY_INGEST_POINT: '__APP_OPEN_REPLAY_INGEST_POINT__',

  APP_POSTHOG_API_HOST: '__APP_POSTHOG_API_HOST__',
  APP_POSTHOG_API_KEY: '__APP_POSTHOG_API_KEY__',
}

Object.entries(jsonEnvs).forEach(([key, defaultValue]) => {
  if (envs[key] === `__${key}__`) {
    settings.env[key] = ''
    return
  }
  settings.env[key] = defaultValue
  if (settings.env[key] === `__${key}__`) {
    settings.env[key] = ''
  }
  try {
    const json = JSON.parse(envs[key])
    if (json !== undefined && json !== null) {
      settings.env[key] = json
    }
  } catch {
    if (envs[key]) {
      settings.env[key] = envs[key]
    }
  }
})

export {settings}
